import { render, staticRenderFns } from "./TagsCreate.vue?vue&type=template&id=c818b1d4&"
import script from "./TagsCreate.vue?vue&type=script&lang=js&"
export * from "./TagsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports